import BaseService from '@/services/services/tools/baseService';
import { getEntityIdFromNavFullId } from '@/business/utils/display';
import PropertiesApi from '@/services/api/internal/heatingIgnition/properties.api';

function checkPreIgnition(visits) {
  if (!visits) return null;
  const visit = visits
    .sort(
      (itvA, itvB) =>
        new Date(itvB.date_d_intervention) - new Date(itvA.date_d_intervention)
    )
    .find(
      (v) =>
        new Date(v.date_d_intervention).getFullYear() ===
        new Date().getFullYear()
    );
  if (!visit) {
    return null;
  }
  return visit.l_installation_est_elle_pret === 'OUI';
}

const PropertiesService = new BaseService({
  api: PropertiesApi,
  treatListResponse: (val) => {
    return val.data.data.map((el) => ({
      ...el,
      ...el.setupParam,
      ignition_event:
        el.ignition_event &&
        el.ignition_event.sort(
          (eventA, eventB) =>
            new Date(eventB.client_request_datetime) -
            new Date(eventA.client_request_datetime)
        ),
      valid_visit: checkPreIgnition(el.visits),
      entity_id: getEntityIdFromNavFullId(el.nav_full_id),
    }));
  },
});

export default PropertiesService;
